// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Details Panel Container */
.details-panel {
  width: var(--details-width);
  height: 100vh;
  background: var(--color-bg-surface);
  border-left: 1px solid var(--color-border-default);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

/* Header */
.details-header {
  padding: var(--spacing-lg) var(--spacing-xl);
  padding-bottom: 1.65rem;
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
}

.details-header__title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  line-height: var(--line-height-tight);
}

.details-close-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color var(--transition-fast);
}

.details-close-btn:hover {
  background: var(--color-bg-hover);
}

.details-close-btn__icon {
  width: 20px;
  height: 20px;
}

/* Invert close icon in dark theme */
[data-theme="dark"] .details-close-btn__icon {
  filter: invert(1);
}

/* Content Area */
.details-content {
  flex: 1;
  padding: var(--spacing-lg) var(--spacing-xl);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  overflow-y: auto;
}

/* Field Container */
.details-field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

/* Labels */
.details-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  line-height: var(--line-height-tight);
}

.details-label__icon {
  width: 16px;
  height: 16px;
}

/* Invert label icons in dark theme */
[data-theme="dark"] .details-label__icon {
  filter: invert(1);
}

/* Inputs */
.details-input {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  font-family: var(--font-family-base);
  line-height: var(--line-height-normal);
  transition: border-color var(--transition-fast);
}

.details-input:focus {
  outline: none;
  border-color: var(--color-primary);
}

.details-input--title {
  font-weight: var(--font-weight-medium);
}

.details-input--date {
  cursor: pointer;
}

.details-input::placeholder {
  color: var(--color-text-placeholder);
}

/* Textarea */
.details-textarea {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
  font-family: var(--font-family-base);
  line-height: var(--line-height-relaxed);
  resize: vertical;
  min-height: 114px;
  transition: border-color var(--transition-fast);
}

.details-textarea:focus {
  outline: none;
  border-color: var(--color-primary);
}

.details-textarea::placeholder {
  color: var(--color-text-placeholder);
}

/* Priority Buttons */
.priority-buttons {
  display: flex;
  gap: var(--spacing-sm);
}

.priority-btn {
  flex: 1;
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.priority-btn:hover {
  background: var(--color-bg-hover);
}

.priority-btn--active {
  background: var(--color-bg-active);
  border-color: var(--color-primary);
  color: var(--color-primary-text);
}

/* Tags */
.details-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
  min-height: 8px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: 3px var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-tight);
}

.tag[data-tag="Work"] {
  background: var(--color-tag-work-bg);
  border: 1px solid var(--color-tag-work-border);
  color: var(--color-tag-work-text);
}

.tag[data-tag="Personal"] {
  background: var(--color-tag-personal-bg);
  border: 1px solid var(--color-tag-personal-border);
  color: var(--color-tag-personal-text);
}

.tag[data-tag="Urgent"] {
  background: var(--color-tag-urgent-bg);
  border: 1px solid var(--color-tag-urgent-border);
  color: var(--color-tag-urgent-text);
}

.tag[data-tag="Important"] {
  background: var(--color-tag-important-bg);
  border: 1px solid var(--color-tag-important-border);
  color: var(--color-tag-important-text);
}

.tag__remove {
  width: 12px;
  height: 12px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity var(--transition-fast);
}

.tag__remove:hover {
  opacity: 1;
}

.tag__remove-icon {
  width: 100%;
  height: 100%;
}

/* Select Dropdown */
.details-select {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  font-family: var(--font-family-base);
  cursor: pointer;
  transition: border-color var(--transition-fast);
}

.details-select:focus {
  outline: none;
  border-color: var(--color-primary);
}

/* Checklist */
.details-checklist {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.checklist-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-xs) 0;
}

.checklist-item__checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid var(--color-border-default);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.checklist-item__checkbox:hover {
  border-color: var(--color-primary);
}

.checklist-item__checkbox--checked {
  background: var(--color-checkbox-checked);
  border-color: var(--color-checkbox-checked);
}

.checklist-item__check {
  color: var(--color-text-inverse);
  font-size: 14px;
  line-height: 1;
}

.checklist-item__label {
  flex: 1;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  cursor: pointer;
  line-height: var(--line-height-normal);
}

.checklist-item__label--done {
  text-decoration: line-through;
  color: var(--color-text-muted);
}

.checklist-item__remove {
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.checklist-item:hover .checklist-item__remove {
  opacity: 0.6;
}

.checklist-item__remove:hover {
  opacity: 1;
}

.checklist-item__remove-icon {
  width: 12px;
  height: 12px;
}

/* Invert checklist remove icon in dark theme */
[data-theme="dark"] .checklist-item__remove-icon {
  filter: invert(1);
}

.checklist-add {
  display: flex;
  gap: var(--spacing-sm);
  align-items: center;
}

.details-input--checklist {
  flex: 1;
}

.btn-add-checklist {
  width: 42px;
  height: 42px;
  padding: 0;
  border: none;
  background: var(--color-primary);
  border-radius: var(--radius-md);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color var(--transition-fast);
  flex-shrink: 0;
}

.btn-add-checklist:hover {
  background: var(--color-primary-hover);
}

.btn-add-checklist__icon {
  width: 18px;
  height: 18px;
}

/* Invert plus icon on light theme for checklist add button */
[data-theme="light"] .btn-add-checklist__icon {
  filter: invert(1);
}

/* Footer */
.details-footer {
  padding: var(--spacing-lg) var(--spacing-xl);
  border-top: 1px solid var(--color-border-default);
}

.btn-delete {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-md);
  padding: var(--spacing-sm) var(--spacing-md);
  border: none;
  background: transparent;
  border-radius: var(--radius-md);
  color: var(--color-error);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn-delete:hover {
  background: rgba(239, 68, 68, 0.08);
}

.btn-delete__icon {
  width: 18px;
  height: 18px;
  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)
    brightness(94%) contrast(96%) !important;
}

.btn-delete__icon--danger {
  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)
    brightness(94%) contrast(96%) !important;
}

/* Invert date/time picker icons in dark theme (inside input) */
[data-theme="dark"] .details-input--date::-webkit-calendar-picker-indicator,
[data-theme="dark"] .details-input--time::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

/* Empty State */
.details-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--spacing-xl);
}

.details-empty__text {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  text-align: center;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/details-panel.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,aAAa;EACb,mCAAmC;EACnC,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,4CAA4C;EAC5C,6CAA6C;EAC7C,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,4CAA4C;EAC5C,6CAA6C;EAC7C,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,4CAA4C;EAC5C,6CAA6C;EAC7C,+BAA+B;EAC/B,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,uCAAuC;EACvC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,4CAA4C;EAC5C,6CAA6C;EAC7C,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;4CAC0C;AAC5C;;AAEA;EACE;4CAC0C;AAC5C;;AAEA,+DAA+D;AAC/D;;EAEE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX","sourcesContent":["/* Details Panel Container */\n.details-panel {\n  width: var(--details-width);\n  height: 100vh;\n  background: var(--color-bg-surface);\n  border-left: 1px solid var(--color-border-default);\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n/* Header */\n.details-header {\n  padding: var(--spacing-lg) var(--spacing-xl);\n  padding-bottom: 1.65rem;\n  border-bottom: 1px solid var(--color-border-default);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 58px;\n}\n\n.details-header__title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0;\n  line-height: var(--line-height-tight);\n}\n\n.details-close-btn {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color var(--transition-fast);\n}\n\n.details-close-btn:hover {\n  background: var(--color-bg-hover);\n}\n\n.details-close-btn__icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Invert close icon in dark theme */\n[data-theme=\"dark\"] .details-close-btn__icon {\n  filter: invert(1);\n}\n\n/* Content Area */\n.details-content {\n  flex: 1;\n  padding: var(--spacing-lg) var(--spacing-xl);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xl);\n  overflow-y: auto;\n}\n\n/* Field Container */\n.details-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n/* Labels */\n.details-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-muted);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  line-height: var(--line-height-tight);\n}\n\n.details-label__icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* Invert label icons in dark theme */\n[data-theme=\"dark\"] .details-label__icon {\n  filter: invert(1);\n}\n\n/* Inputs */\n.details-input {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  background: var(--color-bg-surface);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-base);\n  font-family: var(--font-family-base);\n  line-height: var(--line-height-normal);\n  transition: border-color var(--transition-fast);\n}\n\n.details-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.details-input--title {\n  font-weight: var(--font-weight-medium);\n}\n\n.details-input--date {\n  cursor: pointer;\n}\n\n.details-input::placeholder {\n  color: var(--color-text-placeholder);\n}\n\n/* Textarea */\n.details-textarea {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  background: var(--color-bg-surface);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-base);\n  font-family: var(--font-family-base);\n  line-height: var(--line-height-relaxed);\n  resize: vertical;\n  min-height: 114px;\n  transition: border-color var(--transition-fast);\n}\n\n.details-textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.details-textarea::placeholder {\n  color: var(--color-text-placeholder);\n}\n\n/* Priority Buttons */\n.priority-buttons {\n  display: flex;\n  gap: var(--spacing-sm);\n}\n\n.priority-btn {\n  flex: 1;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.priority-btn:hover {\n  background: var(--color-bg-hover);\n}\n\n.priority-btn--active {\n  background: var(--color-bg-active);\n  border-color: var(--color-primary);\n  color: var(--color-primary-text);\n}\n\n/* Tags */\n.details-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n  min-height: 8px;\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: 3px var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-tight);\n}\n\n.tag[data-tag=\"Work\"] {\n  background: var(--color-tag-work-bg);\n  border: 1px solid var(--color-tag-work-border);\n  color: var(--color-tag-work-text);\n}\n\n.tag[data-tag=\"Personal\"] {\n  background: var(--color-tag-personal-bg);\n  border: 1px solid var(--color-tag-personal-border);\n  color: var(--color-tag-personal-text);\n}\n\n.tag[data-tag=\"Urgent\"] {\n  background: var(--color-tag-urgent-bg);\n  border: 1px solid var(--color-tag-urgent-border);\n  color: var(--color-tag-urgent-text);\n}\n\n.tag[data-tag=\"Important\"] {\n  background: var(--color-tag-important-bg);\n  border: 1px solid var(--color-tag-important-border);\n  color: var(--color-tag-important-text);\n}\n\n.tag__remove {\n  width: 12px;\n  height: 12px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.7;\n  transition: opacity var(--transition-fast);\n}\n\n.tag__remove:hover {\n  opacity: 1;\n}\n\n.tag__remove-icon {\n  width: 100%;\n  height: 100%;\n}\n\n/* Select Dropdown */\n.details-select {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  background: var(--color-bg-surface);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  font-family: var(--font-family-base);\n  cursor: pointer;\n  transition: border-color var(--transition-fast);\n}\n\n.details-select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n/* Checklist */\n.details-checklist {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.checklist-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-xs) 0;\n}\n\n.checklist-item__checkbox {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--color-border-default);\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.checklist-item__checkbox:hover {\n  border-color: var(--color-primary);\n}\n\n.checklist-item__checkbox--checked {\n  background: var(--color-checkbox-checked);\n  border-color: var(--color-checkbox-checked);\n}\n\n.checklist-item__check {\n  color: var(--color-text-inverse);\n  font-size: 14px;\n  line-height: 1;\n}\n\n.checklist-item__label {\n  flex: 1;\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  cursor: pointer;\n  line-height: var(--line-height-normal);\n}\n\n.checklist-item__label--done {\n  text-decoration: line-through;\n  color: var(--color-text-muted);\n}\n\n.checklist-item__remove {\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.checklist-item:hover .checklist-item__remove {\n  opacity: 0.6;\n}\n\n.checklist-item__remove:hover {\n  opacity: 1;\n}\n\n.checklist-item__remove-icon {\n  width: 12px;\n  height: 12px;\n}\n\n/* Invert checklist remove icon in dark theme */\n[data-theme=\"dark\"] .checklist-item__remove-icon {\n  filter: invert(1);\n}\n\n.checklist-add {\n  display: flex;\n  gap: var(--spacing-sm);\n  align-items: center;\n}\n\n.details-input--checklist {\n  flex: 1;\n}\n\n.btn-add-checklist {\n  width: 42px;\n  height: 42px;\n  padding: 0;\n  border: none;\n  background: var(--color-primary);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.btn-add-checklist:hover {\n  background: var(--color-primary-hover);\n}\n\n.btn-add-checklist__icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* Invert plus icon on light theme for checklist add button */\n[data-theme=\"light\"] .btn-add-checklist__icon {\n  filter: invert(1);\n}\n\n/* Footer */\n.details-footer {\n  padding: var(--spacing-lg) var(--spacing-xl);\n  border-top: 1px solid var(--color-border-default);\n}\n\n.btn-delete {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-sm) var(--spacing-md);\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-md);\n  color: var(--color-error);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.btn-delete:hover {\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.btn-delete__icon {\n  width: 18px;\n  height: 18px;\n  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)\n    brightness(94%) contrast(96%) !important;\n}\n\n.btn-delete__icon--danger {\n  filter: invert(41%) sepia(80%) saturate(4880%) hue-rotate(350deg)\n    brightness(94%) contrast(96%) !important;\n}\n\n/* Invert date/time picker icons in dark theme (inside input) */\n[data-theme=\"dark\"] .details-input--date::-webkit-calendar-picker-indicator,\n[data-theme=\"dark\"] .details-input--time::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n\n/* Empty State */\n.details-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: var(--spacing-xl);\n}\n\n.details-empty__text {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-muted);\n  text-align: center;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
